// 后端响应状态码
export enum RES_CODE {
    SUCCESS = 1, // 成功
    NEED_LOGIN = 302, // 需要重新登录
    UN_AUTHORIZED = 401, // 未授权，请联系管理员
}
